<template>
  <div>
    <!--    搜索部分-->
		<el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
			<el-form-item label="终端类型">
				<el-select v-model="enquiryForm.pos_type" medium clearable placeholder="请选择终端类型">
					<el-option label="杉峰Pro平台" value="10"></el-option>
					<el-option label="河马付" value="20"></el-option>
					<el-option label="手机POS" value="30"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
    <div style="height: 36px;margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium"  style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="dialog = true">下拨</el-button>
      <el-button size="medium" type="success" style="font-size: 12px;" @click="importSn">导入</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium" type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
    </div>
    <!-- //打印 -->
    <prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
    <!--    表格部分-->
    <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
              v-loading="loading" border id="tableDataId" size="mini">
      <el-table-column header-align="center" align="center" prop="id" label="ID" sortable></el-table-column>
      <el-table-column header-align="center" align="center" prop="device_code" label="SN号"></el-table-column>
      <el-table-column header-align="center" align="center" prop="create_time" label="入库时间"></el-table-column>
      <el-table-column header-align="center" align="center" prop="force_time" label="下拨时间"></el-table-column>
      <el-table-column header-align="center" align="center" prop="merchant_status" label="商户状态"></el-table-column>
      <el-table-column header-align="center" align="center" prop="user_name" label="盟友名称"></el-table-column>
      <el-table-column header-align="center" align="center" prop="pos_type_name" label="设备类型"></el-table-column>
      <el-table-column header-align="center" align="center" prop="bind_time" label="绑定时间"></el-table-column>
      <el-table-column header-align="center" align="center" prop="activate_time" label="激活时间"></el-table-column>
    </el-table>
    <!-- 分页部分 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
                   layout="total, sizes, prev, pager, next, jumper" style="text-align: right">
    </el-pagination>

    <!-- 导入表单部分-->
    <el-dialog v-if="dialogVisible" title="导入" :visible.sync="dialogVisible" :before-close="cancelDialog" >
      <el-form>
        <el-form-item label="选择机型" :label-width="formLabelWidth" prop="start_device_code"
                      style="margin-bottom: 17px;margin-left: 200px">
          <el-select v-model="enquiryForm.org_type" medium clearable placeholder="请选择机型">
            <el-option v-for="item in posData"
                       :key="item.mer_name"
                       :label="item.mer_name"
                       :value="item.pos_type">
              <span>{{ item.mer_name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 200px">
          <el-upload drag
                     :limit=limitNum
                     :auto-upload="false"
                     accept=".xlsx"
                     :action="UploadUrl()"
                     :before-upload="beforeUploadFile"
                     :on-change="fileChange"
                     :on-exceed="exceedFile"
                     :on-success="handleSuccess"
                     :on-error="handleError"
                     :on-remove="handleRemove"
                     :file-list="fileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip" style="margin-left: 110px">只能上传xlsx文件</div>
          </el-upload>
        </el-form-item>
        <div>
          <el-link :href="templateAddress" type="primary">示例模板下载</el-link>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!--    下拨部分-->
    <el-drawer
        title="下拨"
        :before-close="handleClose"
        :visible.sync="dialog"
        direction="rtl"
        custom-class="demo-drawer"
        ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <el-form-item label="开始机身" :label-width="formLabelWidth" prop="start_device_code"
                        style="margin-bottom: 17px;">
            <el-input size="medium" clearable v-model="form.start_device_code"
                      placeholder="请输入开始SN号" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="结束机身" :label-width="formLabelWidth" prop="end_device_code"
                        style="margin-bottom: 17px;width: 300px">
            <el-input size="medium" clearable v-model="form.end_device_code" placeholder="请输入结N"
                      style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="调拨数量" :label-width="formLabelWidth" prop="transfer_quantity"
                        style="margin-bottom: 17px;width: 300px">
            <el-input size="medium" clearable v-model="form.transfer_quantity"
                      placeholder="请输入调拨数量" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="代理商" :label-width="formLabelWidth" prop="agent" style="margin-bottom: 17px;width: 300px">
            <el-input placeholder="请选择" v-model="form.agent" size="medium" :disabled="true" style="width: 300px">
              <el-button slot="append" @click="mechanismSearch">选择</el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="closeDrawer('ruleForm')">确定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!--      代理商选择表单部分-->
    <el-dialog v-if="mechanismVisible" title="配置表单" :visible.sync="mechanismVisible">
      <!--    搜索部分-->
      <el-form :inline="true" :model="dialogForm" class="demo-form-inline" style="text-align: left">
        <el-form-item label="名称">
          <el-input
              size="medium"
              clearable
              v-model="dialogForm.user_name"
              placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
              size="medium"
              clearable
              v-model="dialogForm.mobile_phone"
              placeholder="请输入"></el-input>
        </el-form-item>
          <el-button
              size="medium"
              type="primary"
              style="font-size: 12px;"
              @click="handleSearch1(dialogForm)">搜索
          </el-button>
          <el-button
              size="medium"
              style="font-size: 12px;"
              @click="handleSearch2(dialogForm)">重置
          </el-button>
      </el-form>
      <!--    表格部分-->
      <el-table
          height="250"
          :data="dialogData"
          style="width: 100%"
          :default-sort="{prop: 'date', order: 'descending'}"
          v-loading="loading2"
          border
          @row-click="singleElection">
        <el-table-column align="center" width="55">
          <template slot="header">
            <span style="cursor:pointer" @click="cancelClick2">取消</span>
          </template>
          <template slot-scope="scope">
            <el-radio class="radio" v-model="templateSelection" :label="scope.row.id"
            >{{ '&nbsp;' }}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="id"
            label="ID"
            sortable>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="user_name"
            label="代理商名称">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="mobile_phone"
            label="代理商手机号">
        </el-table-column>
      </el-table>
      <!-- 分页部分 -->
      <el-pagination
          background
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :page-sizes="[20,50,100,200,500,1000]"
          :page-size="page_size1"
          :total="dialogTotal"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right"
      ></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog2">取 消</el-button>
        <el-button type="primary" @click="submitForm2">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {export_json_to_excel} from "@/excel/Export2Excel";
import prints from '@/components/print.vue'
import { exit } from "process";

export default {
  name: "machineInventory",//机具库存页面
  components: {
    prints
  },
  data() {
    return {
      // 主页面部分
      loading: true, //列表loadding
      page_size: 20, //条数
      total: 0, //总数
      tableData: [], //表格数据
      enquiryForm: {
        page: 1,
        page_size: 20,
        org_type: '',
        pos_type:''
      },
      dialogVisible: false, //表单页面显示
      posData: '',
      templateAddress: 'https://lm.wondpay.com/static/machineImportExample.xlsx',//导入模板下载地址
      limitNum: 1,  // 上传excell时，同时允许上传的最大数
      fileList: [],   // excel文件列表
      //下拨部分
      dialog: false,
      loading1: false,
      form: {
        transfer_type: 10,//调拨类型（10-下拨、-20-回拨）
        start_device_code: "",
        end_device_code: "",
        transfer_quantity: "",
        agent: "",
        user_id: ''
      },
      formLabelWidth: '80px',
      timer: null,
      rules: {
        start_device_code: [
          {required: true, message: '请输入开始SN号', trigger: 'blur'},
        ],
        end_device_code: [
          {required: true, message: '请输入结束SN号', trigger: 'blur'}
        ],
        transfer_quantity: [
          {required: true, message: '请输入数量', trigger: 'blur'}
        ],
        agent: [
          {required: true, message: '请选择代理商', trigger: 'blur'}
        ]
      },
      // 代理商表单部分
      loading2: true, //列表loadding
      page_size1: 20, //表单条数
      dialogTotal: 0,  //表单总数
      dialogData: [],//表单数据
      mechanismVisible: false,//代理商选择表单开启
      dialogCodeVisible: false,//邀请码表单页面显示
      dialogForm: {//表单搜索数据
        page_size: 20,
        mobile_phone: "",//手机号码
        page: 1,
        user_name: "",//用户名称
      },
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [],
      //打印
      tableTh: null,
      tableTd: null,
    }
  },
  created() {
    this.getData(this.enquiryForm)
    this.getPosData()
    this.tableTh = ['ID', '盟友名称', 'SN号', '商户号', '商户名称', '真实姓名','设备类型', '绑定时间', '激活时间'];
    this.tableTd = ['id', 'user_name', 'device_code', 'merchant_code', 'merchant_name', 'real_name','pos_type_name','bind_time', 'activate_time'];
    this.$nextTick(() => {
      this.$refs.prints.prints();
    })
  },
  methods: {
    //打印
    printEvent() {
      this.$nextTick(() => {
        this.$refs.prints.prints();
        this.$refs.prints.print();
      })
    },
    // 主页面部分
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.page_size = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/machine/stockList?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    //获取产品类型数据
    getPosData() { //初始化数据
      this.loading = true;
      this.$api.post("/api/goods/posTypeList", {}, res => {
        if (res.status == 200) {
          this.posData = res.data;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    // 导出
    exportData() {
      let th = ['ID', '盟友名称', 'SN号', '商户号', '商户名称', '真实姓名','设备类型', '绑定时间', '激活时间'];
      let excelData = ['id', 'user_name', 'device_code', 'merchant_code', 'merchant_name', 'real_name','pos_type_name', 'bind_time', 'activate_time'];
      let data = this.formatJson(excelData, this.tableData);
      let defaultTitle = '导出文件';
      export_json_to_excel(th, data, defaultTitle)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    //导入表单显示
    importSn() {
      this.dialogVisible = true;
    },
    //导入表单取消
    cancelDialog() {
      this.dialogVisible = false;
      this.fileList = [];
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`);
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      // console.log(file.raw);
      this.fileList.push(file.raw);
      // console.log(this.fileList);
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      // console.log('before upload');
      // console.log(file);
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      // let size = file.size / 1024 / 1024;
      if (extension !== 'xlsx') {
        this.$message.warning('只能上传后缀是.xlsx的文件');
      }
      // if(size > 10) {
      //   this.$message.warning('文件大小不得超过10M');
      // }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success('文件上传成功');
    },
    handleRemove() {
      this.fileList = [];
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error('文件上传失败');
    },
    UploadUrl: function () {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，
      // 所以这里将action设置为一个返回为空的方法就行，避免抛错
      return ""
    },
    //导入操作 
    submitForm() {
      if (this.enquiryForm.org_type == '') {
        this.$message.warning('请选择终端类型');
      } else {
        if (this.fileList.length === 0) {
          this.$message.warning('请上传文件');
        } else {
          let form = new FormData();
          form.append('file_excel', this.fileList[0]);
          form.append('pos_type', this.enquiryForm.org_type);
          this.$api.post("/api/machine/importMachine", form, res => {
            if (res.status == 200) {
              // this.posData = res.data;
              this.$message.success(res.msg);
              this.dialogVisible = false;
              //刷新页面 
              this.enquiryForm.page = 1;
              this.getData(this.enquiryForm);
            } else {
              this.$message.error(res.msg);
            }
            //清空数据
            this.fileList = [];
            //渲染结束后取消加载
            this.loading = false;
          })
        }
      }

    },
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      this.searchForm.pos_type = '';
      this.getData(searchForm);
    },
    //下拨部分
    handleClose() {
      this.loading1 = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
    //下拨取消
    cancelForm() {
      this.loading1 = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
    //下拨确定
    closeDrawer(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 添加确定
          this.$api.post("/api/machine/forceAllot", this.form, res => {
            if (res.status == 200) {
              this.$message({
                type: 'success',
                message: '下拨成功',
                duration: 1000,
              });
              this.dialog = false;
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
// 代理商选择页面显示（表单显示）
    mechanismSearch() {
      this.mechanismVisible = true;
      this.getDialogData(this.dialogForm);
    },
    //表单分页
    handleCurrentChange1(page) { //当前选中页
      this.dialogForm.page = page;
      this.getDialogData(this.dialogForm);
    },
    handleSizeChange1(limit) { //表单条数
      this.dialogForm.page_size = limit;
      this.dialogForm.page = 1;
      this.getDialogData(this.dialogForm);
    },
    //表单获取数据
    getDialogData(params) { //初始化数据
      this.loading2 = true;
      this.$api.post("/api/agent/getUserAgent?page=" + params.page, params, res => {
        if (res.status == 200) {
          let dialogData = res.data;
          this.dialogTotal = dialogData.total; //总数
          this.dialogData = dialogData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading2 = false;
      })
    },
    //获取每行
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = row;
    },
    //取消
    cancelClick2() {
      this.checkList = [];
      this.templateSelection = '';
    },
    // 表单确定
    submitForm2() {
      this.form.agent = this.checkList.user_name;
      this.form.user_id = this.checkList.id;
      this.handleSearch2(this.dialogForm);
      this.cancelClick2();
      this.mechanismVisible = false;
    },
    //表单取消
    cancelDialog2() {
      this.handleSearch2(this.dialogForm);
      this.cancelClick2();
      this.mechanismVisible = false;
    },
    //表单搜索
    handleSearch1(dialogForm) {
      dialogForm.page = 1;
      this.getDialogData(dialogForm);
    },
    //表单重置
    handleSearch2(dialogForm) {
      dialogForm.page = 1;
      dialogForm.mobile_phone = '';
      dialogForm.user_name = '';
      this.getDialogData(dialogForm);
    },
  }
}
</script>

<style scoped>
/deep/ .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

/deep/ .is-required {
  width: 400px;
}

.code {
  cursor: pointer;
}

/deep/ .demo-drawer__footer {
  text-align: center;
}

/deep/ .el-dialog__body {
  text-align: center;
}

.code:hover {
  color: blue;
  text-decoration: underline;
}

.el-select {
  display: contents !important;
}

/deep/ .el-dialog {
  width: 50% !important;
}
</style>
